module.exports = __webpack_public_path__ + "img/7R.85f83466.jpg";